export default __webpack_public_path__ + "static/media/painting17.f397634c.jpg";